import { gql } from 'graphql-request';

// Sprint 11, story-042 (U77). Reads story-041's slot-fulfillment query directly — no
// client-side re-derivation of fulfillment, per docs/ux/story-042-design.md's explicit rule.
export const EVIDENCE_SLOT_STATE_FIELDS = gql`
  fragment EvidenceSlotStateFields on EvidenceSlotStateDto {
    slotId
    label
    required
    repeatable
    status
    captures {
      documentId
      thumbnailUrl
      capturedAt
      capturedByName
      captureChannel
      deliveryStatus
      dispositionType
      dispositionReason
    }
  }
`;

export const getEvidenceSlotStatusForTask = gql`
  query getEvidenceSlotStatusForTask($taskId: String!) {
    getEvidenceSlotStatusForTask(taskId: $taskId) {
      ...EvidenceSlotStateFields
    }
  }
  ${EVIDENCE_SLOT_STATE_FIELDS}
`;

export const getEvidenceSlotStatusForProject = gql`
  query getEvidenceSlotStatusForProject($projectId: String!) {
    getEvidenceSlotStatusForProject(projectId: $projectId) {
      ...EvidenceSlotStateFields
    }
  }
  ${EVIDENCE_SLOT_STATE_FIELDS}
`;

export const getEvidenceSlotStatusByProject = gql`
  query getEvidenceSlotStatusByProject($projectId: String!) {
    getEvidenceSlotStatusByProject(projectId: $projectId) {
      taskId
      taskName
      slots {
        ...EvidenceSlotStateFields
      }
    }
  }
  ${EVIDENCE_SLOT_STATE_FIELDS}
`;

const EvidenceSlotGraphQL = {
  queries: {
    getEvidenceSlotStatusForTask,
    getEvidenceSlotStatusForProject,
    getEvidenceSlotStatusByProject,
  },
};

export default EvidenceSlotGraphQL;
